/**
 * Created by razial on 18.09.2026.
 */

cleverapps.InitByFeature["dailytasks"] = function () {
    cleverapps.dailyTasks = new DailyTasks();
};

DataLoader.TYPES.DAILY_TASKS = "_daily_tasks";

cleverapps.EVENTS.EARN.DAILY_TASKS = "daily_tasks";
cleverapps.EVENTS.DAILY_TASK_AVAILABLE = "daily_task_available";
cleverapps.EVENTS.DAILY_TASK_FINISH = "daily_task_finish";
cleverapps.EVENTS.DAILY_TASK_REWARD = "daily_task_rewarded";
cleverapps.EVENTS.DAILY_TASKS_OPEN_WINDOW = "daily_tasks_open_window";
cleverapps.EVENTS.DAILY_TASKS_START = "daily_tasks_start";

SyncAdapters.dailytasks = {
    beforeUpdate: () => cleverapps.dailyTasks.beforeUpdate(),
    afterUpdate: () => cleverapps.dailyTasks.update(),

    getInfo: () => cleverapps.dailyTasks.getInfo(),

    updateInfo: (serverData) => {
        cleverapps.dailyTasks.load(serverData);
        cleverapps.dailyTasks.save(false);
    }
};

Activities.TYPES.DAILY_TASK = 1;

Activities.CONFIG[Activities.TYPES.DAILY_TASK] = {
    probability: 0.5,
    messages: [{
        title: "Activity.DailyTask.title",
        body: "Activity.DailyTask.body1"
    }, {
        title: "Activity.DailyTask.title",
        body: "Activity.DailyTask.body2"
    }]
};

Forces.DAILY_TASKS_FORCE = {
    id: 10,
    text: "Forces.DailyTasks"
};

ToolbarItem.DAILY_TASKS = {
    type: 4,
    icon: bundles.toolbar.frames.toolbar_daily_tasks_icon_png,
    force: Forces.DAILY_TASKS_FORCE
};
